import { useMemo } from 'react';

import { exportTextWidgetContent } from '../../../../report/widgetExportHelpers';
import type { WidgetInstanceCapabilities, WidgetReportExportOptions } from '../../../../runtime/instanceRegistry/types';
import { useRegisterWidgetInstance } from '../../../../runtime/instanceRegistry/useRegisterWidgetInstance';

// -- type definitions --

export interface TextInstanceRegistrationContext {
  readonly dashboardElementId: number;
  readonly widgetId: string;
  readonly textValue?: string;
  readonly enabled: boolean;
}

// -- hook --

/**
 * Register a text widget instance.
 *
 * The following capabilities are registered:
 * - for-report content extraction: text format
 */
export function useTextInstanceRegistration(
  ctx: TextInstanceRegistrationContext
): void {
  const capabilities = useMemo<WidgetInstanceCapabilities | null>(() => {
    if (!ctx.enabled) {
      return null;
    }

    return {
      dashboardElementId: ctx.dashboardElementId,
      widgetId: ctx.widgetId,
      reportExports: [
        {
          format: 'text',
          export: async (options: WidgetReportExportOptions) =>
            exportTextWidgetContent(ctx.widgetId, ctx.textValue, options.locale),
        },
      ],
    };
  }, [
    ctx.dashboardElementId,
    ctx.enabled,
    ctx.textValue,
    ctx.widgetId,
  ]);

  useRegisterWidgetInstance(capabilities);
}
